import FormElementRelationMixin from '../../../../../spine-appkit-vue/src/components/form/mixins/FormElementRelationMixin';

Vue.asyncComponent('cms-media-control', {
    mixins: [FormElementRelationMixin],
    props: {
        baseUri: {
            type: String,
            required: false,
            default: ''
        },
        extensions: {
            type: String,
            required: true,
        },
        mimeTypes: {
            type: String,
            required: true,
        },
        size: {
            type: String | Number,
            required: true,
        },
        multiple: {
            type: String | Number,
            required: false,
            default: false
        },
        allowDirectory: {
            type: Boolean,
            required: false,
            default: false
        },
        maximumNumberOfFiles: {
            type: String | Number,
            required: false
        },
        recommendedFileSize: {
            type: String,
        },
        cta: {
            type: String,
            required: false,
            default()  {
                return this.multiple ? "Drop uw bestanden hier" : "Drop uw bestand hier";
            }
        },
    },
    data() {
        return {
            currentRelation: null,
            enableForeignList: true,
            imageValue: [],
        }
    },
    computed: {
        /**
         * The Media Library route object
         * @returns {{name: string, params: {}}}
         */
        mediaLibraryRoute() {
            let params = {};
            params = Object.assign(params, this.$route.params);

            if(params.relationString != undefined) {
                params.relationString += ':' + this.mediaLibraryRelationString;
            } else {
                params.relationString = this.mediaLibraryRelationString;
            }

            return {
                name: this.$route.name,
                params: params,
                query: this.$route.query
            }
        },
        /**
         * The string for the relation for the media list
         * @returns {string}
         */
        mediaLibraryRelationString() {
            return `${this.id}:list:${this.currentRelation.foreignList.bundle}:${this.currentRelation.foreignList.id}`;
        },
    },
    watch: {
        currentRelation: {
            deep: true,
            handler() {
                this.setMediaObjects(this.currentRelation.selected);
            }
        },
        imageValue: {
            deep: true,
            handler() {
                this.setMediaObjects(this.imageValue);
            }
        },
    },
    methods: {
        /**
         * Set the new value for media objects
         *
         * @param newValue
         */
        setMediaObjects(newValue) {
            // if we allow multiple values we concat the selected items in the relation width the imageValue
            if (this.multiple) {
                this.currentValue = this.imageValue.concat(this.currentRelation.selected);
                return;
            }
            // else we use the newValue given in the params
            // This can be a selected item in the relation or a imageValue

            this.currentValue = [];
            if(newValue[0]) {
                // we need to use splice otherwise vue doesn't pickup the change
                this.currentValue.splice(0, 1, newValue[0]);
            }
        },
        /**
         * Check if the given object is a file object
         * @param object
         * @returns {boolean}
         */
        isFileObject(object) {
            return object.downloadPath !== undefined;
        },
        /**
         * Trigger Close
         */
        triggerClose() {
            let leftOverRelationString = this.$route.params.relationString.substring(0, this.$route.params.relationString.indexOf(this.relationString))

            if (leftOverRelationString.endsWith(':')) {
                leftOverRelationString = leftOverRelationString.slice(0, -1);
            }

            this.$router.push({
                ...this.$route,
                params: {
                    ...this.$route.params,
                    relationString: leftOverRelationString ? leftOverRelationString : null
                }
            });
        },
        /**
         * Trigger edit form for media object
         * @param object
         */
        edit(object) {
            let params = this.$route.params;

            if(! params.relationString) {
                params.relationString = this.id;
            } else {
                params.relationString += ':' + this.id;
            }
            // add the formDefinition & object Id to the relation ID
            params.relationString = params.relationString + ':form:'+ this.currentRelation.foreignList.bundle + ':form:' + object.id;

            //redirect to the new relation state
            this.$router.push({ name: this.$route.name , params: params});
        }
    }
}, 'cms/form/controls/cms-media-control.html');
